<template>
  <v-btn
      color="secondary"
      :loading="isLoading"
      :disabled="isDisabled"
      v-on="$listeners"
  >
    <v-icon left>mdi-close</v-icon>
    Cancelar
  </v-btn>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "CancelButton",
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});
</script>